export const Resources = {
  Contact: {
    url:
      "https://api.hsforms.com/submissions/v3/integration/submit/4915476/4f3f57e9-770a-41dc-a06b-5983a4da6102",
    name: "Contact",
  },
  NewsLetter: {
    url:
      "https://api.hsforms.com/submissions/v3/integration/submit/4915476/2bd4d907-9b8f-4e13-9f88-02a2ae7fdabc",
    name: "NewsLetter",
  },
}

export type ResourceType = keyof typeof Resources
